import React from "react";

function CreateOrder({ width = 20, height = 20, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 11.6667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H8.33333V4.16667H4.16667V15.8333H15.8333V11.6667H17.5Z"
        fill={fill}
      />
      <path
        d="M17.4993 5.83333H14.166V2.5H12.4993V5.83333H9.16602V7.5H12.4993V10.8333H14.166V7.5H17.4993V5.83333Z"
        fill={fill}
      />
    </svg>
  );
}

export default CreateOrder;
